<script lang="ts" setup>
/**
 * Augments the default NuxtImg by decoding the URL that comes from Magnolia resolvers to prevent duplicate encoding issues.
 * As well as generating the src with any renames and alts
 */
import type {Asset, FocalPointAsset, FromResolver} from "../types/magnolia-types";
import {definePassedOnProps} from "../utils/definePassedOnProps";

const props = defineProps<{
  asset: FromResolver<Asset | FocalPointAsset>,
  format?: string;
  rendition?: string;
}>();

const alt = computed(() => {
  return props.alt ?? resolveAssetAlt(props.asset);
});
const passedOnProps = computed(() => definePassedOnProps(props));
const src = getAssetLink(props.asset, props.rendition);
</script>
<template>
  <template v-if="src">
    <NuxtImg v-bind="{...passedOnProps, src, alt}"></NuxtImg>
  </template>
</template>
